import { render } from "./AddEditCollaborators.vue?vue&type=template&id=4e4bf8dd&scoped=true"
import script from "./AddEditCollaborators.vue?vue&type=script&lang=js"
export * from "./AddEditCollaborators.vue?vue&type=script&lang=js"

import "./AddEditCollaborators.vue?vue&type=style&index=0&id=4e4bf8dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4bf8dd"]])

export default __exports__